module.exports = __webpack_public_path__ + "static/media/296294.22540338.png";